import React from 'react';
import { Range } from './Range';

export const PricingComponent = ({
  description,
  setValue,
  title,
  value,
  maxRange,
  step,
  minRange,
  unitDescription,
}: {
  title: string;
  description: string;
  value: number;
  setValue: (value: number) => void;
  maxRange: number;
  step: number;
  minRange?: number;
  unitDescription?: string;
}) => {
  return (
    <div>
      <h2 className="text-br-primary text-xl leading-tight font-semibold">
        {title}
      </h2>
      <p className="mt-2 text-gray-500">{description}</p>
      {unitDescription && (
        <p className="mt-4 font-semibold text-gray-800">{unitDescription}</p>
      )}
      <Range
        value={value}
        setValue={setValue}
        maxRange={maxRange}
        minRange={minRange}
        step={step}
      />
    </div>
  );
};
